var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"basic-hero bg-no-repeat bg-cover",style:({
    background:
      'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' +
      _vm.blok.background_image.filename + '/m/fit-in/1905x530/' +
      ')',
  })},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$storyapi.richTextResolver.render(_vm.blok.text))}})])}
var staticRenderFns = []

export { render, staticRenderFns }